var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 4,
    viewBox: "0 0 19 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.882812 2.10156C0.882812 1.62305 1.05143 1.21517 1.38867 0.87793C1.73047 0.54069 2.13835 0.37207 2.6123 0.37207C3.09082 0.37207 3.4987 0.54069 3.83594 0.87793C4.17773 1.21517 4.34863 1.62305 4.34863 2.10156C4.34863 2.58008 4.17773 2.99023 3.83594 3.33203C3.4987 3.66927 3.09082 3.83789 2.6123 3.83789C2.13835 3.83789 1.73047 3.66927 1.38867 3.33203C1.05143 2.99023 0.882812 2.58008 0.882812 2.10156ZM7.79102 2.10156C7.79102 1.62305 7.95964 1.21517 8.29688 0.87793C8.63867 0.54069 9.04655 0.37207 9.52051 0.37207C9.99902 0.37207 10.4069 0.54069 10.7441 0.87793C11.0859 1.21517 11.2568 1.62305 11.2568 2.10156C11.2568 2.58008 11.0859 2.99023 10.7441 3.33203C10.4069 3.66927 9.99902 3.83789 9.52051 3.83789C9.04655 3.83789 8.63867 3.66927 8.29688 3.33203C7.95964 2.99023 7.79102 2.58008 7.79102 2.10156ZM14.6992 2.10156C14.6992 1.62305 14.8678 1.21517 15.2051 0.87793C15.5469 0.54069 15.9548 0.37207 16.4287 0.37207C16.9072 0.37207 17.3151 0.54069 17.6523 0.87793C17.9941 1.21517 18.165 1.62305 18.165 2.10156C18.165 2.58008 17.9941 2.99023 17.6523 3.33203C17.3151 3.66927 16.9072 3.83789 16.4287 3.83789C15.9548 3.83789 15.5469 3.66927 15.2051 3.33203C14.8678 2.99023 14.6992 2.58008 14.6992 2.10156Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/Ellipsis.3ee90189dd9ab77df896571cbcc9da04.svg";
export { ForwardRef as ReactComponent };